import { render } from "./AreaComercial.vue?vue&type=template&id=cdbbda2a"
import script from "./AreaComercial.vue?vue&type=script&lang=js"
export * from "./AreaComercial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__